import { Component, OnInit,ViewChild} from '@angular/core';
import {Router,ActivatedRoute} from "@angular/router"
import { FormBuilder, FormGroup,  NgForm , Validators,FormControl} from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';
///IDIOMAS
import { lang_dispatch } from 'app/idiomas/i18n/dispatch/dispatch.lang';
import { lang_requerimientos } from 'app/idiomas/i18n/requerimientos/requerimientos.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { RequirementsService } from "../services/requirements.service";
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import {TranslateService} from '@ngx-translate/core';
import { Requerimientos3Service } from "app/main/pagina/tools/requerimientos3/requerimientos3.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DATOS_API } from 'app/auth/auth.datos';
import {Subscription,Subject,BehaviorSubject } from 'rxjs';
import { takeUntil} from 'rxjs/operators';
import { HttpClient} from "@angular/common/http";
import { MatStepper } from '@angular/material/stepper';
import { lang_cierre } from 'app/idiomas/i18n/cierre/cierre.lang';
import { FormAyudaComponent } from "./form-ayuda/form-ayuda.component";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Base64} from 'js-base64';
@Component({
  selector: 'app-requerimientos3',
  templateUrl: './requerimientos3.component.html',
  styleUrls: ['./requerimientos3.component.scss',],
  animations   : fuseAnimations
})
export class Requerimientos3Component implements OnInit {
  // userData:any;
  // form: FormGroup;
  // Only required when not passing the id in methods
  @ViewChild('pasos')  pasos: MatStepper;
  bandera : boolean = false;
  porcentajeAvance:number;
  muestraPorcentaje:boolean;
  parametroProductoId: string;
  parametroEmpresaId: string;
  // validationUser:boolean=false;
  correosPilotos: any[] = [
    {email:''},
    // {email:''},
    // {email:''},
    // {email:''},
    // {email:''}
  ];
  charChinos = '\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC';
  charTurcos = '\u011F\u011E\u0131\u0130\u00F6\u00D6\u00FC\u00DC\u015F\u015E\u00E7\u00C7';
  charIdiomas = this.charChinos + this.charTurcos;
  regexEmail = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?\.)+[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?$");
  autenticacionEncuesta:boolean=false;
  visualizarEncuesta:boolean=false;
  recibiCorreosEncuesta:boolean=false;
  validacionCuestionario:boolean=false;
  finalizaRequerimientos:boolean=false;


  tipoUsuarioAdministrador:boolean=false;

  //variables banderas requerimientos3
  autentication: boolean;
  requirements: boolean;
  testAccess: boolean;
  testEmail: boolean;
  validationQ: boolean;
  requerimientosv3: any={};

  formPreguntas: FormGroup;
  formPreguntas2: FormGroup;

  empresaId:any;
  productoId:any;
  idiomaNativo:any;
  requerimientosExterno:boolean=false;
  cuestionarioCompletas:boolean=false;
  catalogoPreguntas:any;
  catalogoPreguntasAll:any;
  urlEncuesta:any;
  userEncuesta:any;
  NivelUsuario:any;
  urlAssetsEmail= DATOS_API.urlAssets;
  tipoProducto:any;



///Variables cambio de color tema requerimientos externos
fuseConfig: any;
form = this._formBuilder.group({
  colorTheme      : new FormControl(),
  customScrollbars: new FormControl(),
  layout          : this._formBuilder.group({
    style    : new FormControl(),
    width    : new FormControl(),
    navbar   : this._formBuilder.group({
      primaryBackground  : new FormControl(),
      secondaryBackground: new FormControl(),
      folded             : new FormControl(),
      hidden             : new FormControl(),
      position           : new FormControl(),
      variant            : new FormControl()
    }),
    toolbar  : this._formBuilder.group({
      background           : new FormControl(),
      customBackgroundColor: new FormControl(),
      hidden               : new FormControl(),
      position             : new FormControl()
    }),
    footer   : this._formBuilder.group({
      background           : new FormControl(),
      customBackgroundColor: new FormControl(),
      hidden               : new FormControl(),
      position             : new FormControl()
    }),
    sidepanel: this._formBuilder.group({
      hidden  : new FormControl(),
      position: new FormControl()
    })
  })
});
private _unsubscribeAll: Subject<any>;
parametroTema: string;





///Dominios
newsurvey:boolean;
forAllGptw:boolean;
graphics04:boolean;
culture04:boolean;
newsurveyNumIntentos:number=0;
forAllGptwNumIntentos:number=0;
graphics04NumIntentos:number=0;
culture04NumIntentos:number=0;
btnMostrarHelpnewsurvey=false;
btnMostrarHelpforAllGptw=false;
btnMostrarHelpgraphics04=false;
btnMostrarHelpculture04=false;
pasoActual = 0;
siguiente:boolean=false;
rutaDominiosAbsoluta:any;
formularioTI = {
  nombre: '',
  correo: '',
  fecha: '',
  enviado: false,
};
muestraFormularioTI: boolean;

idiomasRtInstituto = "";
institutoIdExterno = localStorage.getItem('instituto');
institutoId = localStorage.getItem('instituto_id');
nombreEmpresaRt="";
dominioCA:boolean=true;
objProduct:any;
surveySubDomain:any;
ipPublic:any;
  constructor(
    private service : RequirementsService,
    private _fuseConfigService: FuseConfigService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private reqService: Requerimientos3Service,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private _http: HttpClient,
    public dialog: MatDialog,
  ) {
    this.NivelUsuario=localStorage.getItem('NivelUsuarioRequerimientosTecnicos');
    console.log('*****++++++Nivel Usuario::::',this.NivelUsuario);


    lang_requerimientos.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_dispatch.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_cierre.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });


    this.idiomaNativo=this.translateSrv.currentLang;
    this.activatedRoute.params.subscribe(params => {
      console.log(params);
        this.parametroProductoId = params.idProducto;
        this.parametroEmpresaId = params.empresaId;
        if(params.lang != undefined){
          this.translateSrv.use(params.lang);
        }
    });

    this.translateSrv.onLangChange.subscribe(() => {
      console.log('idioma traducción',this.translateSrv.currentLang)
      this.idiomaNativo=this.translateSrv.currentLang;
      if (this.NivelUsuario=='2' || this.NivelUsuario=='3') {
        console.log('No hace nada ');

      }else{
        this.getCuestionarioRequerimientosTecnico();
        console.log('lo traen chido');


      }

   });


    //habilita o inhabilita formulario
    let userBypass = JSON.parse(localStorage.getItem('userBypass'));
    if(this.NivelUsuario == '10' || this.NivelUsuario == '1'){
      this.muestraFormularioTI = true;
    } else if(userBypass){
      if(userBypass.level == 3 || userBypass.level == 2){
        this.muestraFormularioTI = true;
      } else this.muestraFormularioTI = false;
    } else this.muestraFormularioTI = false;

   }

   ngOnInit() {
     console.log("idioma nativo: ",this.idiomaNativo);
     this.getAbsolutePath();
     if (this.parametroProductoId != undefined) {  /// ACCSO EXTERNO
       this.requerimientosExterno=true;
       this.muestraFormularioTI = true;
       this.productoId=this.parametroProductoId;
       this.empresaId=this.parametroEmpresaId;
       console.log('REQUERIMIENTOS externos');

       this._fuseConfigService.config = {
         layout: {
           navbar   : {hidden: true },
           toolbar  : {hidden: false },
           footer   : {hidden: false },
           sidepanel: {hidden: true }
         }
       };

       this.getCuestionarioRequerimientosTecnico();
       this.getAllCatalogoPreguntas();
       this.getDominiosEstatusExternal();
       this.getFormTI();
       this.getBanderasRequerimientosExterno();
       // this.getUserSurveyRequerimientosTecnicos();

       this._unsubscribeAll = new Subject();
       this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
         // Update the stored config
         this.fuseConfig = config;
         // Set the config form values without emitting an event
         // so that we don't end up with an infinite loop
         this.form.setValue(config, {emitEvent: false});
       });
       this.form.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
         // Update the config
         console.log("cambiara tema");
         this._fuseConfigService.config = config;
       });

      this.cambiaTema(this.institutoIdExterno);

      localStorage.setItem('ToolbarExterno','ToolbarExterno');

    }else{   /// ACCESO INTERNO
      localStorage.removeItem('ToolbarExterno');
      localStorage.getItem('ToolbarExterno');
       this.productoId=localStorage.getItem('productoIDRequerimientos');
       this.empresaId=localStorage.getItem('companyID');
       console.log('productoId',this.productoId);
       console.log('empresaId',this.empresaId);
       this.tipoProducto=localStorage.getItem('idProductoRT');
       console.log('tipoProducto',this.tipoProducto);
       this.surveySubDomain = localStorage.getItem('surveySubDomain') != 'undefined' ? localStorage.getItem('surveySubDomain') : undefined;
       this.ipPublic = localStorage.getItem('ipPublicSubDomain') != 'undefined' ? localStorage.getItem('ipPublicSubDomain') : undefined;
       console.log('ipPublic',this.ipPublic);

       if (this.tipoProducto=='57'|| this.tipoProducto=='58') {
         this.dominioCA=false;
       }
       this.idiomasRtInstituto = this.institutoId;
       // this.idiomasRtInstituto=localStorage.getItem('institutoRquerimientos');
       console.log('idiomasRtInstituto',this.idiomasRtInstituto);
       if (this.NivelUsuario=='2' || this.NivelUsuario=='3') {
        this.tipoUsuarioAdministrador=true;

       }else{
         this.getBanderasRequerimientos();
         this.getCuestionarioRequerimientosTecnico();
         this.tipoUsuarioAdministrador=false;
         this.getAllCatalogoPreguntas();
         this.getDominiosEstatus();
         this.getFormTI();
         this.getUserSurveyRequerimientosTecnicos();
       }

     }

    this.formPreguntas = this._formBuilder.group({
      question1: ['', Validators.required],
      question2: ['', Validators.required],
      question3: ['', Validators.required],
      question4: ['', Validators.required],
      question5: ['', Validators.required],
      question6: ['', Validators.required],
      question7: ['', Validators.required],
      // question8: ['', Validators.required],
    });
   }

   getFormTI(){
     this.reqService.getFormTI(this.empresaId, this.productoId).subscribe((respuesta:any) => {
       console.log("getFormTI:",respuesta);
       if(respuesta.success){
         this.formularioTI.nombre = respuesta.rtform.fullName;
         this.formularioTI.correo = respuesta.rtform.email;
         this.formularioTI.fecha = respuesta.rtform.createdAt;
         this.formularioTI.enviado = true;
       }
     });
   }

   getInfoEmpresaExt(empresaId){
     this.reqService.getInfoEmpresa(empresaId).subscribe((respuesta:any) => {
       console.log("getInfoEmpresa:",respuesta);
       if(respuesta.success){
        this.idiomasRtInstituto=respuesta.instituo.toString();
        this.institutoId=respuesta.instituo.toString();
        this.nombreEmpresaRt=respuesta.nombreEmpresa;
        this.getUserSurveyRequerimientosTecnicos();
       }
     });
   }

   async saveFormTI(){
     if(this.formularioTI.nombre == ''){
       this.mensajeSwal(this.translateSrv.instant('REQUERIMIENTOSV3.FORMULARIO_TI.MENSAJES.NOMBRE'), 2);
     } else{
       const datoCorrecto = this.regexEmail.test(this.formularioTI.correo);
       if(!datoCorrecto){
         this.mensajeSwal(this.translateSrv.instant('DISPATCH.ALERT.ERRMAIL'), 2);
       } else{
         Swal.fire({
           // title: this.translateSrv.instant('CIERRE.CARGANDOCORREO'),
           title: this.translateSrv.instant('REQUERIMIENTOSV3.FORMULARIO_TI.MENSAJES.GUARDANDO'),
           allowOutsideClick: false,
           didOpen: () => {
             Swal.showLoading()
           }
         });
         const datos = {
           companyId: this.empresaId,
           productId: this.productoId,
           fullName: this.formularioTI.nombre,
           email: this.formularioTI.correo
         };
         const saveForm:any = await this.reqService.saveFormTI(datos).toPromise().then((respuesta) => { return respuesta });
         if(this.tipoProducto == 68){   // SI ES EL PRODUCTO SWIFT
           // this.requerimientosv3.requirements = true;
           // const actualizaBandera = await this.reqService.setBanderasRequerimientosTecnicosExternos(this.empresaId,this.productoId,this.requerimientosv3).toPromise().then((respuesta:any) => { return respuesta });
           // this.getBanderasRequerimientosExterno();
           // console.log("actualizaBandera:",actualizaBandera);
           this.setBanderasRequerimientos('validacion');
         }
         console.log("saveFormTI:",saveForm);
         if(saveForm.success){
           Swal.close();
           this.formularioTI.enviado = true;
           this.formularioTI.fecha = saveForm.rtform.createdAt;
           this.mensajeSwal(this.translateSrv.instant('REQUERIMIENTOSV3.FORMULARIO_TI.MENSAJES.GUARDADO'), 1);
         }
         //});

       }
     }
   }

   cambiaTema(instituto){
 console.log('instituto********************',instituto);

     if(instituto!=8){
       console.log("entrro",instituto);

         this.form.controls['colorTheme'].setValue('temaFocusArea2');
     }
   }

   saveData(){
    console.log(this.formPreguntas.value);
  }

  //////funcion get Banderas requerimientos tecnicos///////
  getBanderasRequerimientos(){

    this.reqService.getBanderasRequerimientosTecnicos(this.empresaId,this.productoId).subscribe((respuesta:any) => {
      console.log(respuesta);
      this.objProduct=respuesta;
      if (respuesta.requerimientosv3.autentication== true) {
        this.autenticacionEncuesta=true;
      }else{
        this.autenticacionEncuesta=false;
      }
      if (respuesta.requerimientosv3.testAccess== true) {
        this.visualizarEncuesta=true;
      }else{
        this.visualizarEncuesta=false;
      }
      if (respuesta.requerimientosv3.testEmail== true) {
        this.recibiCorreosEncuesta=true;
      }else{
        this.recibiCorreosEncuesta=false;
      }
      if (respuesta.requerimientosv3.validationQ== true) {
        this.validacionCuestionario=true;
      }else{
        this.validacionCuestionario=false;
      }
      if (respuesta.requerimientosv3.requirements== true) {
        this.finalizaRequerimientos=true;
      }else{
        this.finalizaRequerimientos=false;
      }


      this.autentication= respuesta.requerimientosv3.autentication;
      this.requirements= respuesta.requerimientosv3.requirements;
      this.testAccess= respuesta.requerimientosv3.testAccess;
      this.testEmail=   respuesta.requerimientosv3.testEmail;
      this.validationQ= respuesta.requerimientosv3.validationQ;



     this.calculaAvance(this.autentication,this.testAccess,this.testEmail,this.validationQ,this.requirements);

      // this.validacionInterval(this.testEmail);
    });
  }




  validacionInterval(estatus:boolean){
    if (!estatus) {
      let intervalo= setInterval(()=>{
        console.log('se inicio el intervalo: ');

          this.reqService.getBanderasRequerimientosTecnicosExternos(this.empresaId,this.productoId).subscribe((respuesta:any) => {
           if (respuesta.requerimientosv3.testEmail==true) {
             console.log('entro esta Bandera ');

             this.getBanderasRequerimientosExterno();
             clearInterval(intervalo);
           }
          });
      },20000)
    }
  }


  //////funcion get Banderas requerimientos tecnicos externo///////
  getBanderasRequerimientosExterno(){

    this.reqService.getBanderasRequerimientosTecnicosExternos(this.empresaId,this.productoId).subscribe((respuesta:any) => {
      console.log(respuesta);
      this.objProduct=respuesta;
      this.surveySubDomain=this.objProduct.survey_subdomain;
      if(respuesta.ipPublic != undefined ){
        this.ipPublic = respuesta.ipPublic;
      }
      if (respuesta.requerimientosv3.autentication== true) {
        this.autenticacionEncuesta=true;
      }else{
        this.autenticacionEncuesta=false;
      }
      if (respuesta.requerimientosv3.testAccess== true) {
        this.visualizarEncuesta=true;
      }else{
        this.visualizarEncuesta=false;
      }
      if (respuesta.requerimientosv3.testEmail== true) {
        this.recibiCorreosEncuesta=true;
      }else{
        this.recibiCorreosEncuesta=false;
      }
      if (respuesta.requerimientosv3.validationQ== true) {
        this.validacionCuestionario=true;
      }else{
        this.validacionCuestionario=false;
      }
      if (respuesta.requerimientosv3.requirements== true) {
        this.finalizaRequerimientos=true;
      }else{
        this.finalizaRequerimientos=false;
      }


      this.autentication= respuesta.requerimientosv3.autentication;
      this.requirements= respuesta.requerimientosv3.requirements;
      this.testAccess= respuesta.requerimientosv3.testAccess;
      this.testEmail=   respuesta.requerimientosv3.testEmail;
      this.validationQ= respuesta.requerimientosv3.validationQ;
      this.tipoProducto=respuesta.idProducto;
      if (this.tipoProducto==57|| this.tipoProducto==58) {
        this.dominioCA=false;
      }

      this.getInfoEmpresaExt(this.empresaId);

     this.calculaAvance(this.autentication,this.testAccess,this.testEmail,this.validationQ,this.requirements);
    // this.validacionInterval(this.testEmail);
    });
  }

  //////funcion actualiza Banderas requerimientos tecnicos interno y externo///////
  setBanderasRequerimientos(tipo){
    let datos:any={};
    let requerimientosv3:any={};


    // let mensajeSuccess='REQUERIMIENTOSV3.MENSAJES.MENSAJE_SUCCESS_OK';
    // this.translateSrv.get(mensajeSuccess).subscribe((res: string) => { mensajeSuccess = res; });
    switch (tipo) {
      case 'auten':
        console.log('auten');
        datos.autentication= true;
        datos.requirements= this.requirements;
        datos.testAccess= this.testAccess;
        datos.testEmail= this.testEmail;
        datos.validationQ= this.validationQ;
       requerimientosv3.requerimientosv3=datos,
      this.requerimientosv3=requerimientosv3;
      console.log(requerimientosv3);
        break;
      case 'access':
        console.log('testAccess');
        datos.autentication= this.autentication;
        datos.requirements= this.requirements;
        datos.testAccess= true;
        datos.testEmail= this.testEmail;
        datos.validationQ= this.validationQ;
       requerimientosv3.requerimientosv3=datos,
      this.requerimientosv3=requerimientosv3;
      console.log(requerimientosv3);

        break;
      case 'testCorreo':
        console.log('testEmail');
        datos.autentication= this.autentication;
        datos.requirements= this.requirements;
        datos.testAccess= this.testAccess;
        datos.testEmail= true;
        datos.validationQ= this.validationQ;
       requerimientosv3.requerimientosv3=datos,
      this.requerimientosv3=requerimientosv3;
      console.log(requerimientosv3);

        break;
      case 'question':
        console.log('// QUESTION: ');
        datos.autentication= this.autentication;
        datos.requirements= this.requirements;
        datos.testAccess= this.testAccess;
        datos.testEmail= this.testEmail;
        datos.validationQ= true;
       requerimientosv3.requerimientosv3=datos,
      this.requerimientosv3=requerimientosv3;
      console.log(requerimientosv3);

        break;
      case 'validacion':
      console.log('validacion');

        datos.autentication= this.autentication;
        datos.requirements= true;
        datos.testAccess= this.testAccess;
        datos.testEmail= this.testEmail;
        datos.validationQ= this.validationQ;
       requerimientosv3.requerimientosv3=datos,
      this.requerimientosv3=requerimientosv3;
      console.log(requerimientosv3);

        break;

      default:
        break;
    }
    this.objProduct.requerimientosv3=datos;
    console.log('objProduct',this.objProduct);

    this.modalGuardado(1);
    if (this.requerimientosExterno) {
      console.log('ejecuto servicio fuera de plataforma y ya jalo jaja');

            this.reqService.setBanderasRequerimientosTecnicosExternos(this.empresaId,this.productoId,this.objProduct).subscribe((respuesta:any) => {
              console.log(respuesta);
              if (tipo=='question' ) {
                console.log('entro cuestionario');
                this.guardarFormulario();

              }else{
                console.log('no es cuestionario');

                Swal.close();
                this.getBanderasRequerimientosExterno();
                this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.MENSAJES.MENSAJE_SUCCESS_OK'),'OK');


              }
            });
    }else{
      console.log('ejecuto servicio dentro de plataforma');

      this.reqService.setBanderasRequerimientosTecnicos(this.empresaId,this.productoId,this.objProduct).subscribe((respuesta:any) => {
        console.log(respuesta);
        if (tipo=='question' ) {
          console.log('entro cuestionario');
          this.guardarFormulario();

        }else{
          console.log('no es cuestionario');

          Swal.close();
          this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.MENSAJES.MENSAJE_SUCCESS_OK'),'OK');

          this.getBanderasRequerimientos();

        }
      });

    }

  }

  guardarFormulario(){
    console.log("se guardaron las Respuestas");
    let question:any[]=[];
    let questions=[];
    let newJson={};
    let referenciaDataSet= this.formPreguntas2;
    this.catalogoPreguntasAll.forEach((element,i) => {
      questions.push({
        "answers":element.answers,
        "answersSelected": [{answer:referenciaDataSet.controls[`question${i}`].value}],
        "questionLanguage": element.questionLanguage,
        "_id": element._id,
        "typeQuestion": element.typeQuestion,
        });


    });
    newJson={questions}
    console.log("Json armado del cuestionario",newJson);

    this.reqService.saveCuestionarioRequerimientosTecnicos(this.productoId,newJson).subscribe((respuesta:any) => {
      console.log(respuesta);
      Swal.close();
      if(this.requerimientosExterno){
        this.getBanderasRequerimientosExterno();
      }
      else{
      this.getBanderasRequerimientos();
      }
      this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.MENSAJES.MENSAJE_SUCCESS_OK'),'OK');

    });


  }

  getCuestionarioRequerimientosTecnico(){
    console.log("se guardaron las Respuestas");
    console.log('this.productoId'),this.productoId;

    this.reqService.getCatalogoPreguntasRequerimientos(this.productoId,this.idiomaNativo).subscribe((respuesta:any) => {
    console.log(respuesta);
    console.log(respuesta.data);

    this.catalogoPreguntas=respuesta.data;

    this.creaFormGroupsCuestionario(this.catalogoPreguntas);
    });
  }

  getAllCatalogoPreguntas(){

    this.reqService.getAllCatalogoCuestionarios(this.productoId).subscribe((respuesta:any) => {
    console.log(respuesta);
    this.catalogoPreguntasAll=respuesta.questions;
    console.log(this.catalogoPreguntasAll);
    });

  }


  calculaAvance(autentication,testAccess,testEmail,validationQ,requirements){
if (autentication==true && testAccess==false && testEmail==false && validationQ==false && requirements==false) {
  this.porcentajeAvance=20;
}else if (autentication==true && testAccess==true && testEmail==false && validationQ==false && requirements==false) {
  this.porcentajeAvance=40;
}else if (autentication==true && testAccess==true && testEmail==true && validationQ==false && requirements==false) {
  this.porcentajeAvance=60;
}else if (autentication==true && testAccess==true && testEmail==true && validationQ==true && requirements==false) {
  this.porcentajeAvance=80;
}else if (autentication==true && testAccess==true && testEmail==true && validationQ==true && requirements==true) {
  this.porcentajeAvance=100;
}
  }


  validarDato(dato:any,numCampo:number){
    let datoCorrecto = true;
    datoCorrecto = this.regexEmail.test(dato.target.value);
    console.log("datos ingresados:: ",datoCorrecto);

    if(!datoCorrecto){
      this.mensajeSwal(this.translateSrv.instant('DISPATCH.ALERT.ERRMAIL'), 2);
      this.correosPilotos[numCampo].email = "";
    }
  }

  enviaPilotos(){
    this.modalSendEmail();
    console.log("pilotos:",this.correosPilotos);
    let correctos = false;
    let datos: any = {
      correos: [],
      lang:this.idiomaNativo,
    };
    // if(this.fechaLanzamiento){
      let BreakException = {};
      try {
        this.correosPilotos.forEach(correo => {
          console.log(correo);
          if(correo.email != ""){
            console.log("entro este visne");
            correctos = true;
              datos.correos.push(correo);
            }
        });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      if(correctos){
        console.log("datosAEnviar:",datos);
       if(this.requerimientosExterno ==true){
         this.reqService.envioCorreosPruebasExterno(this.empresaId,this.productoId,datos).subscribe((respuesta:any) => {
           console.log("sendPilotoSMTP:",respuesta);
           Swal.close();
           this.getUserSurveyRequerimientosTecnicos();
         });
        }
        else{

          this.reqService.envioCorreosPruebas(this.empresaId,this.productoId,datos).subscribe((respuesta:any) => {
            console.log("sendPilotoSMTP:",respuesta);
            Swal.close();
            let texto = 'REQUERIMIENTOSV3.PASO3.MSJ_SUCC_EMA_';

            this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
            Swal.fire({
              title: texto,
              icon: "success",
              confirmButtonColor: '#e40601'
            });
            this.getUserSurveyRequerimientosTecnicos();
            // if(respuesta.message == "Success"){
            //   let texto = 'DISPATCH.LABEL06'+'';
            //   let newTexto:string;
            //   this.translateSrv.get(texto).subscribe((res: string) => { newTexto = res; });
            //   Swal.fire({
            //     title: newTexto,
            //     icon: "success",
            //     confirmButtonColor: '#e40601'
            //   });
            // }
          });
        }

      }else{
      console.log("No se puede");
      let texto = 'REQUERIMIENTOSV3.MENSAJES.WAR_ING_CORR';
      let newTexto:string;
      this.translateSrv.get(texto).subscribe((res: string) => { newTexto = res; });
      console.log(newTexto);
      Swal.fire({
        title: newTexto,
        icon: "error",
        confirmButtonColor: '#e40601'
      });
    }
  }


  modalSendEmail(){
    let textSendEmail='CONSULTATABLA.SEN_EMAIL_MODAL';
    this.translateSrv.get(textSendEmail).subscribe((res: string) => { textSendEmail = res; });
     // this.translate.get('CERTIFICAR.FORALL.CARGANDO_PRACTICA').subscribe((res: string) => { mensaje = res; });
console.log(this.urlAssetsEmail+'platform/img/tenor.gif');
    Swal.fire({
      imageUrl:this.urlAssetsEmail+'platform/img/tenor.gif',
      title: textSendEmail,
      allowOutsideClick: false,
      imageWidth: 100,
      imageHeight: 90,
      showConfirmButton:false

    });
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  modalGuardado(tipo:number){
    let mensajeModal:string;
    switch (tipo) {
      case 1:

     mensajeModal='REQUERIMIENTOSV3.MENSAJES.ACTUALIZANDO_REQUERIMIENTOS';
        break;
      case 2:
      mensajeModal='REQUERIMIENTOSV3.PASO3.MSJ_COP_CLA';

        break;
      case 3:
      mensajeModal='REQUERIMIENTOSV3.PASO3.MODAL_VERIFI_INFO';

        break;

      default:
        break;
    }
    this.translateSrv.get(mensajeModal).subscribe((res: string) => { mensajeModal = res; });
    Swal.fire({
      title: mensajeModal,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
  }

  openSuccessSnackBar(message: string, action: string) {
     this.snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['background-success']
     });
  }

  getUserSurveyRequerimientosTecnicos(){
    let inst:any;
    switch (this.idiomasRtInstituto) {
      case 'CAyC': case '2': inst = 2; break;
      default: inst = this.idiomasRtInstituto;
    }
    this.reqService.getUserSurveyRequerimientosTecnicos(inst,this.tipoProducto).subscribe((respuesta:any) => {
    console.log(respuesta);
    this.urlEncuesta=respuesta.getUserSurvey.link;
    // this.urlEncuesta='https://4all.gptw.global/zyu';
    this.userEncuesta=respuesta.getUserSurvey.user;

    });
  }

  saveUserSurveyRequerimientosTecnicos(){
    this.modalGuardado(2);
    let datos ={
      productoId:this.productoId,
      brokerId: this.institutoId,
      idProducto: this.tipoProducto,
    };
    this.reqService.saveUserSurveyRequerimientosTecnicos(this.empresaId,datos).subscribe((respuesta:any) => {
    console.log(respuesta);
    Swal.close();
    this.copyMessage(this.userEncuesta);
    this.getUserSurveyRequerimientosTecnicos();
    });
  }

  copyMessage(userEncuesta){
    this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.COPY_MESSAGE'),'OK');
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value=userEncuesta;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }





updateBanderaDominio(datos){
  this.reqService.updateBanderasDominiosServ(this.empresaId,datos).subscribe((respuesta:any) => {
  console.log(respuesta);
  Swal.close();
this.getDominiosEstatus();
    this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.PASO2.MODAL_SUCCESS_CONEX'),'OK');

  });
}
updateBanderaDominioExternal(datos){
  this.reqService.updateBanderasDominiosServExternal(this.empresaId,datos).subscribe((respuesta:any) => {
  console.log(respuesta);
  Swal.close();
this.getDominiosEstatusExternal();
    this.openSuccessSnackBar(this.translateSrv.instant('REQUERIMIENTOSV3.PASO2.MODAL_SUCCESS_CONEX'),'OK');

  });
}

modalConection(){

  Swal.fire({
    imageUrl:'assets/WimaxTowerAnimation.gif',
    title: this.translateSrv.instant('REQUERIMIENTOSV3.COMPR_CONEXI'),
    allowOutsideClick: false,
    imageWidth: 100,
    imageHeight: 90,
    showConfirmButton:false

  });
}

validacionBandera(stepper:MatStepper){
  this.modalGuardado(3);
  this.reqService.getBanderasRequerimientosTecnicosExternos(this.empresaId,this.productoId).subscribe((respuesta:any) => {
    console.log('respuesta',respuesta);
    if (respuesta.requerimientosv3.testAccess== true) {
      this.visualizarEncuesta=true;
    }else{
      this.visualizarEncuesta=false;
    }
    if (respuesta.requerimientosv3.testEmail== true) {
      this.recibiCorreosEncuesta=true;
    }else{
      this.recibiCorreosEncuesta=false;
    }

   if (respuesta.requerimientosv3.testAccess==true&&respuesta.requerimientosv3.testEmail==true) {
this.pasoActual = 3;
     Swal.close();
     this.calculaAvance(this.autentication,this.testAccess,respuesta.requerimientosv3.testEmail,this.validationQ,this.requirements);
     this.testEmail=respuesta.requerimientosv3.testEmail;
     this.recibiCorreosEncuesta=true;
   }else{
     Swal.close();
     let texto = 'REQUERIMIENTOSV3.PASO3.MODAL_WARNI_BAND';
     this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
     Swal.fire({
       title: texto,
       icon: "warning",
       confirmButtonColor: '#e40601'
     });
   }
  });
}

cambioPosicion(obj:any){
  console.log(obj);

  this.pasoActual = obj.selectedIndex;
  console.log('this.pasoActual::::::',this.pasoActual);

}

 getDominiosEstatus(){
   console.log(this.productoId);
   this.reqService.getBanderasDominiosServ(this.empresaId,this.productoId).subscribe((respuesta:any) => {
   console.log(respuesta);
   this.newsurvey=respuesta.flagDomainStatus.newsurvey;
   this.forAllGptw=respuesta.flagDomainStatus.forAll;
   this.graphics04=respuesta.flagDomainStatus.resultados;
   this.culture04=respuesta.flagDomainStatus.cultureAudit;
   if (this.dominioCA) {
     if (this.newsurvey==true &&this.culture04==true &&this.forAllGptw==true &&this.graphics04==true ) {
       this.siguiente=true;
     }
   }else{
     if (this.newsurvey==true &&this.forAllGptw==true &&this.graphics04==true ) {
       this.siguiente=true;
     }
   }

   });
 }

 getDominiosEstatusExternal(){
   console.log(this.productoId);
   this.reqService.getBanderasDominiosServExternal(this.empresaId,this.productoId).subscribe((respuesta:any) => {
   console.log(respuesta);
   this.newsurvey=respuesta.flagDomainStatus.newsurvey;
   this.forAllGptw=respuesta.flagDomainStatus.forAll;
   this.graphics04=respuesta.flagDomainStatus.resultados;
   this.culture04=respuesta.flagDomainStatus.cultureAudit;
   if (this.dominioCA) {
     if (this.newsurvey==true &&this.culture04==true &&this.forAllGptw==true &&this.graphics04==true ) {
       this.siguiente=true;
     }
   }else{
     if (this.newsurvey==true &&this.forAllGptw==true &&this.graphics04==true ) {
       this.siguiente=true;
     }
   }

   });
 }

 creaFormGroupsCuestionario(datos){
   console.log("datos:::::::::::::",datos);

  let group = {};
  let iterador = 0;
  datos.forEach( (objeto) => {
    group["question"+iterador] = new FormControl('',[Validators.required]);
    iterador++;
  });
  this.formPreguntas2 = new FormGroup(group);
  this.colocaValores();
  this.formPreguntas2.valueChanges.subscribe( (res) => {
    if(this.formPreguntas2.status == 'VALID'){
      this.cuestionarioCompletas=true;
      console.log("Validado");
    }
    else{
      this.cuestionarioCompletas=false;
console.log("no valido");

    }
  });
}

colocaValores(){
  let referenciaDataSet= this.formPreguntas2;
  let i=0;
  // this.datasets.forEach((dataset,idxPag) => {
  for(let control in referenciaDataSet.controls){
    let respuesta=this.catalogoPreguntas[i].answersSelected.length>0 ? this.catalogoPreguntas[i].answersSelected[0].answer : "";
  referenciaDataSet.controls[control].setValue(respuesta);
   i++;
  }

  console.log(`formgroups`,referenciaDataSet);
}

getAbsolutePath() {
  let ruta:any;
    var loc = window.location;
    var pathName = loc.pathname.substring(0, loc.pathname.lastIndexOf('/') + 1);
    ruta=loc.href.substring(0, loc.href.length - ((loc.pathname + loc.search + loc.hash).length - pathName.length));
    console.log('ruta***',ruta);
    this.rutaDominiosAbsoluta=ruta;
    return ruta;

}


copyMessageUrlDomin(){
  // let infraestr= Base64.encode(this.surveySubDomain);
  // let ipPublic= Base64.encode(this.ipPublic);
  let ruta=this.rutaDominiosAbsoluta+'#/domains-ext/'+this.idiomasRtInstituto;
  let texto = 'CIERRE.CIERRE.COPYLINK';
  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  // selBox.value=val;
  selBox.value=ruta;
  console.log(ruta);
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  Swal.fire({
    icon: 'success',
    title: texto,
    confirmButtonText: this.translateSrv.instant('CIERRE.ALERT.OK'),
    // confirmButtonText: this.translateSrv.instant('CIERRE.ALERT.OK'),
  });

}

verModalAyuda(tipoModal){
  const dialogRef = this.dialog.open(FormAyudaComponent, {
    width: '40%',
    height: '50%',
    // padding: '1px',
    data: {
      empresaId: this.empresaId,
      productoId:this.productoId,
      tipoProducto: this.tipoProducto,
      tipoRT:this.requerimientosExterno,
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    if (result==undefined) {
      console.log('no mando nada ');

    }
  });

}

async testConection(typeConec){
  this.modalConection();
  let url:any;
  let datos:any;
  let empresaId=this.empresaId;
  switch (typeConec) {
    case 1:
      if (this.surveySubDomain != undefined ) {
        url = `https://${this.surveySubDomain}.culturalgo.com`;
        datos = { productoId: this.productoId, newsurvey: true };
      }else{
        url = this.tipoProducto == '63' ? 'https://surveyn35.culturalgo.com' : 'https://newsurvey.culturalgo.com';
        datos = { productoId: this.productoId, newsurvey: true };
      }
    break;
    case 2: url='https://4all.gptw.global'; datos = { productoId: this.productoId, forAll: true }; break;
    case 3: url='https://success.culturalgo.com'; datos = { productoId: this.productoId, resultados: true }; break;
    case 4: url='https://culture04.culturalgo.com:8443/'; datos = { productoId: this.productoId, cultureAudit: true }; break;
  }
    if(navigator.onLine ) {
      try {
        const response = await fetch(url,{ mode: 'no-cors'});
        console.log(response);
        if (response) {
          if (this.requerimientosExterno) {
            console.log('UPDATE BANDERAS EXTERNO');
            this.updateBanderaDominioExternal(datos);
          }else{
            console.log('UPDATE BANDERAS Interno');
            this.updateBanderaDominio(datos);
          }
        }
        console.log(response);
        return response;

      } catch (error) {
        switch (typeConec) {
          case 1: this.newsurveyNumIntentos++;
          if (this.newsurveyNumIntentos>=3) {
            this.btnMostrarHelpnewsurvey=true;
          }else{
            this.btnMostrarHelpnewsurvey=false;
          }
           Swal.close();
           break;
          case 2:
          this.forAllGptwNumIntentos++;
           if (this.forAllGptwNumIntentos>=3) {
             this.btnMostrarHelpforAllGptw=true;
           }else{
             this.btnMostrarHelpforAllGptw=false;
           }
           Swal.close();
            break;
          case 3:
          this.graphics04NumIntentos++;
                      if (this.graphics04NumIntentos>=3) {
                        this.btnMostrarHelpgraphics04=true;
                      }else{
                        this.btnMostrarHelpgraphics04=false;
                      }
             Swal.close();
             break;
          case 4: this.culture04NumIntentos++;
              if (this.culture04NumIntentos>=3) {
                this.btnMostrarHelpculture04=true;
              }else{
                this.btnMostrarHelpculture04=false;
              }
          Swal.close();
          break;
          default:
            break;
        }

      }
 }
 }




//  verificarConexion(tipoConexion){
//    this.modalConection();
//         var pingserver = new Image();
//         let datos:any;
//
//    switch (tipoConexion) {
//      case 1:
//      // pingserver.src = "https://newsurvey.culturalgo.com/FondoITBM.jpg";
//      pingserver.src= this.tipoProducto == '63' ? 'https://surveyn35.culturalgo.com/FondoITBM.jpg': 'https://newsurvey.culturalgo.com/FondoITBM.jpg';
//      console.log('pingserver.src',pingserver.src);
//      if (pingserver.height>0) {
//       datos={
//          productoId:this.productoId,
//          newsurvey: true,
//        }
//
//    } else {
//        console.log("no hace nada ");
//
//         }
// setTimeout(() => {
//   // pingserver.src = "https://newsurvey.culturalgo.com/FondoITBM.jpg";
//   pingserver.src= this.tipoProducto == '63' ? 'https://surveyn35.culturalgo.com/FondoITBM.jpg': 'https://newsurvey.culturalgo.com/FondoITBM.jpg';
//   if (pingserver.height>0) {
//    datos={
//       productoId:this.productoId,
//       newsurvey: true,
//     }
//     if (this.requerimientosExterno) {
//       console.log('UPDATE BANDERAS EXTERNO');
//
//     this.updateBanderaDominioExternal(datos);
//   }else{
//     this.updateBanderaDominio(datos);
//
//   }
//
//   } else {
//
//          this.newsurveyNumIntentos++;
//          if (this.newsurveyNumIntentos>=3) {
//            this.btnMostrarHelpnewsurvey=true;
//          }else{
//            this.btnMostrarHelpnewsurvey=false;
//          }
//     console.log("no hace nada despues del setTime ");
// Swal.close();
//      }
//
// }, 2000);
//
//
//        break;
//      case 2:
//      pingserver.src = "https://urlservices.culturalgo.com/FondoITBM.jpg";
//      if (pingserver.height>0) {
//        // datos={
//        //    productoId:this.productoId,
//        //    cultureAudit: true,
//        //  }
//        //  this.updateBanderaDominio(datos);
//
//       } else {
//         console.log(' no hace nada ');
//
//      }
//      setTimeout(() => {
//        pingserver.src = "https://urlservices.culturalgo.com/FondoITBM.jpg";
//        if (pingserver.height>0) {
//         datos={
//            productoId:this.productoId,
//            forAll: true,
//          }
//          if (this.requerimientosExterno) {
//            console.log('UPDATE BANDERAS EXTERNO');
//
//          this.updateBanderaDominioExternal(datos);
//        }else{
//          this.updateBanderaDominio(datos);
//
//        }
//
//        } else {
//          this.forAllGptwNumIntentos++;
//          if (this.forAllGptwNumIntentos>=3) {
//            this.btnMostrarHelpforAllGptw=true;
//          }else{
//            this.btnMostrarHelpforAllGptw=false;
//          }
//          console.log("no hace nada despues del setTime ");
//      Swal.close();
//           }
//
//      }, 2000);
//        break;
//      case 3:
//
//      pingserver.src = "https://success.culturalgo.com/FondoITBM.jpg";
//      if (pingserver.height>0) {
//       } else {
//      }
//      setTimeout(() => {
//        pingserver.src = "https://success.culturalgo.com/FondoITBM.jpg";
//        if (pingserver.height>0) {
//         datos={
//            productoId:this.productoId,
//            resultados: true,
//          }
//          if (this.requerimientosExterno) {
//            console.log('UPDATE BANDERAS EXTERNO');
//
//          this.updateBanderaDominioExternal(datos);
//        }else{
//          this.updateBanderaDominio(datos);
//
//        }
//
//        } else {
//               this.graphics04NumIntentos++;
//               if (this.graphics04NumIntentos>=3) {
//                 this.btnMostrarHelpgraphics04=true;
//               }else{
//                 this.btnMostrarHelpgraphics04=false;
//               }
//          console.log("no hace nada despues del setTime ");
//      Swal.close();
//
//           }
//
//      }, 2000);
//        break;
//      case 4:
//
//      pingserver.src = "https://culture04.culturalgo.com:8443/images/background.png";
//      if (pingserver.height>0) {
//        // datos={
//        //    productoId:this.productoId,
//        //    cultureAudit: true,
//        //  }
//        //  this.updateBanderaDominio(datos);
//
//       } else {
//         console.log(' no hace nada ');
//
//      }
//      setTimeout(() => {
//        pingserver.src = "https://culture04.culturalgo.com:8443/images/background.png";
//        if (pingserver.height>0) {
//         datos={
//            productoId:this.productoId,
//            cultureAudit: true,
//          }
//          if (this.requerimientosExterno) {
//            console.log('UPDATE BANDERAS EXTERNO');
//
//          this.updateBanderaDominioExternal(datos);
//        }else{
//          this.updateBanderaDominio(datos);
//
//        }
//
//        } else {
//          this.culture04NumIntentos++;
//          if (this.culture04NumIntentos>=3) {
//            this.btnMostrarHelpculture04=true;
//          }else{
//            this.btnMostrarHelpculture04=false;
//          }
//          console.log("no hace nada despues del setTime ");
//      Swal.close();
//           }
//
//      }, 2000);
//        break;
//
//      default:
//        break;
//    }
// }
















}
